import styled from 'styled-components';

export const Image = styled.img`
  page-break-inside: avoid !important;
  break-inside: avoid-page !important;
`;

export default Image;
